// @core/api/endpoints/affiliate/list_commission_tiers.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListCommissionTiersResponse,
} from '../../../types/affiliate';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/affiliate';

/**
 * List commission tiers
 * Returns a paginated list of commission tiers. Supports filtering and sorting.
 */
export async function ListCommissionTiers(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListCommissionTiersResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/commission-tiers`;
  const requestOptions = options;
  return client.get<ListCommissionTiersResponse>(requestPath, { ...requestOptions, params });
}
